<template>
  <div class="rc-page-header">
    <slot name="content-header-pre"></slot>
    <h1 v-if="title" v-bind:class="[{ invisible: isInvisible }, headingClass]">
      {{ title }}
    </h1>
    <slot name="content-header-post"></slot>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: ["title", "isInvisible", "headingClass"]
};
</script>
